export const purchaseStatusOptions = {
  STATUS_N: {
    key: 'N',
    text: '待提交',
  },
  STATUS_Y: {
    key: 'Y',
    text: '已提交',
  },
  STATUS_20: {
    key: '20',
    text: '撤回待提交',
  },
  STATUS_30: {
    key: '30',
    text: '审核中',
  },
  STATUS_35: {
    key: '35',
    text: '撤回审核中',
  },
  STATUS_40: {
    key: '40',
    text: '驳回待提交',
  },
  STATUS_45: {
    key: '45',
    text: '审核通过',
  },
  STATUS_50: {
    key:'50',
    text: '待收货',
  },
  STATUS_60: {
    key: '60',
    text: '收货中',
  },
  STATUS_70: {
    key: '70',
    text: '已收货',
  },
  STATUS_75: {
    key: '75',
    text: '待入库',
  },
  STATUS_78: {
    key: '78',
    text: '待出库',
  },
  STATUS_80: {
    key: '80',
    text: '入库中',
  },
  STATUS_85: {
    key: '85',
    text: '出库中',
  },
  STATUS_90: {
    key: '90',
    text: '已入库',
  },
  STATUS_95: {
    key: '95',
    text: '已出库',
  },
  STATUS_100: {
    key: '100',
    text: '已结案',
  },
  STATUS_110: {
    key: '110',
    text: '已作废',
  },
}

export const purchaseStatusValueEnum = Object.fromEntries(
  Object.keys(purchaseStatusOptions).map(k => [k.replace('STATUS_', ''), purchaseStatusOptions[k]])
);

export const purchaseStatusSelectOptions = Object.values(purchaseStatusOptions).map(item => ({
  value: item.key,
  label: item.text
}));


export const applyStatusOptions = {
  STATUS_N: {
    key: 'N',
    text: '待提交',
  },
  STATUS_Y: {
    key: 'Y',
    text: '已提交',
  },
  STATUS_20: {
    key: '20',
    text: '撤回待提交',
  },
  STATUS_30: {
    key: '30',
    text: '审核中',
  },
  STATUS_35: {
    key: '35',
    text: '撤回审核中',
  },
  STATUS_40: {
    key: '40',
    text: '驳回待提交',
  },
  STATUS_45: {
    key: '45',
    text: '审核通过',
  },
  STATUS_100: {
    key: '100',
    text: '已结案',
  },
  STATUS_110: {
    key: '110',
    text: '已作废',
  },
}

export const applyStatusValueEnum = Object.fromEntries(
  Object.keys(applyStatusOptions).map(k => [k.replace('STATUS_', ''), applyStatusOptions[k]])
);

export const applyStatusSelectOptions = Object.values(applyStatusOptions).map(item => ({
  value: item.key,
  label: item.text
}));

export const ReceiveStatusOptions = {
  PRE_RECEIVE: {
    key: 'PRE_RECEIVE',
    text: '预收货'
  },
  RECEIVING: {
    key: 'RECEIVING',
    text: '收货中'
  },
  REJECT: {
    key: 'REJECT',
    text: '驳回'
  },
  RECEIVED: {
    key: 'RECEIVED',
    text: '已收货'
  },
  PRINTED: {
    key: 'PRINTED',
    text: '已打印'
  },
}

export const ReceiveStatusValueEnum = Object.fromEntries(
  Object.keys(ReceiveStatusOptions).map(k => [k.replace('STATUS_', ''), ReceiveStatusOptions[k]])
);

export const ReceiveStatusSelectOptions = Object.values(ReceiveStatusOptions).map(item => ({
  value: item.key,
  label: item.text
}));

export const IncomeStatusOptions = {
  UN_RECEIVE: {
    key: 'UN_RECEIVE',
    text: '未收货'
  },
  RECEIVING: {
    key: 'RECEIVING',
    text: '收货中'
  },
  RECEIVED: {
    key: 'RECEIVED',
    text: '已结单'
  },
}
export const IncomeStatusValueEnum = Object.fromEntries(
  Object.keys(IncomeStatusOptions).map(k => [k.replace('STATUS_', ''), IncomeStatusOptions[k]])
);

export const IncomeStatusSelectOptions = Object.values(IncomeStatusOptions).map(item => ({
  value: item.key,
  label: item.text
}));
export default {
  purchaseStatusOptions,
  purchaseStatusValueEnum,
  purchaseStatusSelectOptions,
  applyStatusOptions,
  applyStatusValueEnum,
  applyStatusSelectOptions,
  ReceiveStatusOptions,
  ReceiveStatusValueEnum,
  ReceiveStatusSelectOptions,
  IncomeStatusOptions,
  IncomeStatusValueEnum,
  IncomeStatusSelectOptions
}
